enum UrlConverterDialogFields {
	URL = "url",
	USERNAME = "username",
	PASSWORD = "password",
	FORMAT = "format",
	ORIENTATION = "orientation",
	WIDTH = "width",
	HEIGHT = "height",
	MARGIN_LEFT = 'margin_left',
	MARGIN_RIGHT = 'margin_right',
	MARGIN_TOP = 'margin_top',
	MARGIN_BOTTOM = 'margin_bottom',
	PREVIEW = "preview",
	UNIT = "unit",
	HEADER_PLAIN = "header_plain",
	HEADER_FONT_FAMILY = "header_font_family",
	HEADER_FONT_COLOR = "header_font_color",
	HEADER_FONT_SIZE = "header_font_size",
	HEADER_ALIGNMENT = "header_alignment",
	HEADER_CONTENT = "header_content",
	HEADER_MARGIN_TOP = "header_margin_top",
	HEADER_MARGIN_BOTTOM = "header_margin_bottom",
	HEADER_MARGIN_LEFT = "header_margin_left",
	HEADER_MARGIN_RIGHT = "header_margin_right",
	FOOTER_PLAIN = "footer_plain",
	FOOTER_FONT_FAMILY = "footer_font_family",
	FOOTER_FONT_COLOR = "footer_font_color",
	FOOTER_FONT_SIZE = "footer_font_size",
	FOOTER_ALIGNMENT = "footer_alignment",
	FOOTER_CONTENT = "footer_content",
	FOOTER_MARGIN_TOP = "footer_margin_top",
	FOOTER_MARGIN_BOTTOM = "footer_margin_bottom",
	FOOTER_MARGIN_LEFT = "footer_margin_left",
	FOOTER_MARGIN_RIGHT = "footer_margin_right"
}

export default UrlConverterDialogFields;